import {FC, useContext, useEffect, useState} from 'react'
import i18n from 'i18next'
import axios from 'axios'
import {FundCatalog} from '../types/FundCatalog'
import {ILanguage} from '../types/common'
import FundTable from '../common/FundTable'
import {AllFundCatalogContext} from './ctx/AllFundCatalogContext'
import {Fund} from '../types/Fund'
import {format} from 'date-fns'

const LayoutALL: FC<{
    language: ILanguage
}> = ({language}) => {
    const [tableData, setTableData] = useState<Fund[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const localCtx: any = useContext(AllFundCatalogContext)
    const dynamicColumns: object = {
        oneDay: {value: '1D', label: '1D'},
        oneMonth: {value: '1M', label: '1M'},
        threeMonths: {value: '3M', label: '3M'},
        sixMonths: {value: '6M', label: '6M'},
        oneYear: {value: '12M', label: '12M'},
        threeYears: {value: '36M', label: '36M'},
        fiveYears: {value: '60M', label: '60M'},
        yearToDate: {value: 'YTD', label: 'YTD'},
        max: {value: 'MAX', label: 'MAX'},
    }

    useEffect(() => {
        const params = new URLSearchParams()
        if (localCtx.date) {
            params.append('date', format(localCtx.date, 'yyyy-MM-dd'))
        }
        axios
            .get<FundCatalog>(
                `${process.env.REACT_APP_API_BASE_URL}/api/fund${params.size || [...params.keys()].length ? '?' + params.toString() : ''}`,
                {
                    headers: {
                        Accept: 'application/json',
                    },
                    auth: {
                        username: `${process.env.REACT_APP_API_USERNAME}`,
                        password: `${process.env.REACT_APP_API_PASSWORD}`,
                    },
                }
            )
            .then((result) => {
                const today: Date = new Date(result.data.today)
                let begin: Date = new Date(2100, 0, 1)
                let end: Date = new Date(1900, 0, 1)
                const items: Fund[] = result.data.items
                const holiday = result.data.holiday.map((item) => {
                    return new Date(item)
                })

                items.forEach((item) => {
                    if (begin > new Date(item.begin)) {
                        begin = new Date(item.begin)
                    }
                })

                items.forEach((item) => {
                    if (end < new Date(item.end)) {
                        end = new Date(item.end)
                    }
                })

                localCtx.setHoliday(holiday)
                localCtx.setMinDate(begin)
                localCtx.setMaxDate(end)
                localCtx.setToday(today)

                setTableData(items)
                setIsLoading(false)
            })
            .catch((error) => {
                console.error(error)
            })
    }, [localCtx.date])

    useEffect(() => {
        i18n.changeLanguage(language)
    }, [language])

    return (
        <>
            <FundTable
                mode={'heart'}
                language={language}
                data={tableData}
                isLoading={isLoading}
                ctx={localCtx}
                dynamicColumns={dynamicColumns}
            />
        </>
    )
}

export default LayoutALL
